export const ColorfulLine = () => {
    return (
        <span style={{ display: 'flex' }}>
            <div style={{ backgroundColor: "#FF9933", height: 3, flex: 1 }} />
            <div style={{ backgroundColor: "#6666FF", height: 3, flex: 1 }} />
            <div style={{ backgroundColor: "#99CC33", height: 3, flex: 1 }} />
            <div style={{ backgroundColor: "#339966", height: 3, flex: 1 }} />
        </span>
    )
};